module.exports = __webpack_public_path__ + "static/Logo-424f4aad2475b5882559536202fe3b63.png";